import { Flex, Box } from "@rebass/grid/emotion"
import styled from "@emotion/styled"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"

export const AltContentsContainer = styled.div`
  width: 100%;
  margin: auto;
`
export const ButtonsWrap = styled(Flex)`
  margin-left: auto;
  flex-direction: column;

  button.c-btn {
    width: 100%;
    height: 56px;
    @media (min-width: 768px) {
      height: 56px;
    }
    padding-left: 0;
    padding-right: 0;
  }
`
export const RadioHolder = styled(Box)`
  position: relative;
  width: 100%;
  border-radius: 4px;
  margin: auto;
  height: auto;
  z-index: 5;
  //max-width: 440px;
  @media (min-width: 768px) {
    max-width: none;
  }
`
export const RadioWrap = styled.button`
  width: 100%;
  font-size: 0;
  position: relative;
  border-radius: 8px;
  background: ${theme.wild.color.master.base.default};
  border: 1px solid ${theme.wild.color.master.base.alt.default};
  padding: 15px 16px;
  @media (min-width: 768px) {
    height: auto;
    min-height: auto;
  }
  @media (min-width: 1024px) {
    padding: 16px 24px;
  }

  &:not(:last-of-type) {
    margin-bottom: 8px;
  }

  span:not(.hidden, .atc-test-control, .block) {
    display: inline;
  }

  svg {
    display: inline-block;
  }

  &.selected {
    background: ${theme.wild.color.master.primary.alt};
    border-color: ${theme.wild.color.master.primary.default};

    .radio-button {
      border: 7px solid ${theme.wild.color.master.primary.default};
    }
  }

  .radio-button {
    height: 22px;
    width: 22px;
    border-radius: 50%;
    position: relative;
    border: 1px solid ${theme.wild.color.men.base.alt.default};
    background: ${theme.wild.color.master.base.default};
    @media (min-width: 1024px) {
      top: 2px;
    }
  }

  .body--small.c-strike {
    text-decoration: line-through;
    line-height: 18px;
    font-size: 12px;
    flex: 1;
    text-align: right;
  }

  &.normal {
    border-radius: 8px;
    padding: 8px;
  }

  &.has-savings-tag&:first-of-type {
    margin-top: 24px;
    border-top-right-radius: 0;

    &:before {
      content: ${(props) => `"${props.savingstag}"`};
      display: block;
      position: absolute;
      color: #fff;
      width: 112px;
      height: 24px;
      top: -24px;
      right: -1px;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      font-size: 12px;
      line-height: 24px;
      font-weight: 700;
      font-family: ${theme.wild.font.dinamo.regular};
      background: ${theme.wild.color.master.primary.default};

      @media (min-width: 1024px) {
        width: 126px;
        font-size: 14px;
      }
    }
  }
`

export const RadioRow = styled(Flex)`
  flex-direction: row;

  &.row0 {
    /* span:not(.c-savings) { */

    span {
      line-height: 24px !important;
      @media (min-width: 440px) {
        line-height: 22px !important;
      }
      @media (min-width: 768px) {
        line-height: 22px !important;
      }
      @media (min-width: 1024px) {
        line-height: 26px !important;
      }
    }
  }

  &.row1 {
    margin: 8px 0 0 0;
  }

  .c-price {
    flex: 1;
    text-align: right;
    @media (min-width: 768px) and (max-width: 1023px) {
      &.TextElementNova.men[class*="title--small"] {
        font-size: 20px;
      }
    }
  }

  .c-title {
    width: 50%;
    text-align: left;
    @media (min-width: 360px) {
      width: 48%;
    }
    @media (min-width: 768px) {
      max-width: 182px;
      width: 44%;
      @media (max-width: 1023px) {
        &.TextElementNova.men[class*="title--small"] {
          font-size: 20px;
        }
      }
    }
    @media (min-width: 1024px) {
      width: 34%;
    }
  }

  span.c-savings {
    border-radius: 4px;
    padding: 1px 0 0 0;
    text-align: center;
    width: 24%;
    height: 24px;
    max-width: 67px;
    background: ${theme.color.yellow};
    color: ${theme.wild.color.master.base.black};
    @media (min-width: 768px) {
      padding: 2px 0 0 0;
    }
    @media (min-width: 1024px) {
      transform: translate(0, -2px);
      font-size: 14px !important;
      max-width: 79px;
      height: 30px;
      line-height: 30px !important;
      padding: 0;
    }
  }

  .c-description {
    width: 81%;
    text-align: left;

    span.body--regular {
      font-family: "Dinamo Regular", Helvetica, Arial, sans-serif !important;
    }

    .block {
      display: block !important;
    }

    .text-master-primary-default-special {
      color: #005752 !important;
    }

    @media (min-width: 1024px) {
      max-width: none;
      padding-right: 12px;
      width: 90%;
      span {
        font-size: 12px !important;
        line-height: 130% !important;
      }
    }
  }
`
export const BuyOnce = styled(Box)``
